import { useAppSelector } from '@/state/store';
import WorldIntro from '@/components/WorldIntro';

export default function SceneSelectorLayout({ children }: { children: React.ReactNode }) {
    return <WorldIntro>{children}</WorldIntro>;
}
